import { createBaseChartConfig } from "../../lib/chart-config-builder";
import { createStandardKpiConfig, transformSimpleData, transformGroupedData } from "../../lib/data-transformer";
/**
 * Transform configurations for each KPI Global Performance type
 */
export const KPI_GLOBAL_PERFORMANCE_CONFIGS = {
    area: {
        transformData: (data) => {
            const config = createStandardKpiConfig({
                kpiNameField: "kpi",
                kpiValueField: "value",
                isGrouped: false,
            });
            return transformSimpleData(data, config, "Area");
        },
        chartConfig: createBaseChartConfig(),
    },
    region: {
        transformData: (data) => {
            const config = createStandardKpiConfig({
                kpiNameField: "kpi",
                kpiValueField: "value",
                isGrouped: true,
                groupLabelGetter: (item) => item.region_name,
            });
            return transformGroupedData(data, config);
        },
        chartConfig: createBaseChartConfig(),
    },
    delegation: {
        transformData: (data) => {
            const config = createStandardKpiConfig({
                kpiNameField: "kpi",
                kpiValueField: "value",
                isGrouped: true,
                groupLabelGetter: (item) => item.delegation_name,
            });
            return transformGroupedData(data, config);
        },
        chartConfig: createBaseChartConfig(),
    },
    sala: {
        transformData: (data) => {
            const config = createStandardKpiConfig({
                kpiNameField: "kpi",
                kpiValueField: "value",
                isGrouped: true,
                groupLabelGetter: (item) => `Sala ${item.sala}`,
                filterZeroValues: true,
            });
            return transformGroupedData(data, config);
        },
        chartConfig: createBaseChartConfig(),
    },
    distribuidor: {
        transformData: (data) => {
            const config = createStandardKpiConfig({
                kpiNameField: "kpi",
                kpiValueField: "value",
                isGrouped: true,
                groupLabelGetter: (item) => item.distribuidor || "(Sin nombre)",
                maxItems: 15,
                filterZeroValues: true,
                truncateLabelLength: 25,
            });
            return transformGroupedData(data, config);
        },
        chartConfig: createBaseChartConfig({ maxTicksLimit: 20 }),
    },
};
/**
 * Get transform function and chart config for a specific type
 */
export function getKpiGlobalPerformanceConfig(type) {
    const config = KPI_GLOBAL_PERFORMANCE_CONFIGS[type];
    if (!config) {
        throw new Error(`Unknown KPI Global Performance type: ${type}`);
    }
    return config;
}
